import React from "react";
import { useForm } from "react-hook-form";

/**
 *
 * @param {String} title
 * @param {Array<String>} answers
 * @returns
 */
const Question = ({ title, answers, name, state, setState }) => {
  return (
    <div className="question-num">
      <p className="question-title">{title}</p>
      <div className="answer-chk">
        {answers?.map((answer, key) => (
          <label key={key} className="check-container">
            <input
              type="radio"
              name={name}
              value={key + 1}
              onChange={() => setState(key + 1)}
              checked={state === key + 1}
            />
            <span className="checkmark"></span>
            <span>{answer}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default Question;
